export default __webpack_public_path__ + "static/media/Footpad's Belt of the Burning Temple.b7b1846e.jpg";